"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMenu = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledMenu = styled_components_1.default.div `
  border-radius: 6px;
  cursor: pointer;
  display: ${(props) => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  justify-content: space-between;
  padding: 10px 0px;
  transform: ${(props) => props.large
    ? 'translate3d(-160px, -140px, 0px)'
    : 'translate3d(-160px, -110px, 0px)'};
  width: 180px;
`;
